import React from 'react';
import './SendMessageButton.css'; // Assuming you'll create a CSS file for it

const SendMessageButton = ({ onClick, children, disabled }) => {
  return (
    <button className="send-message-btn" onClick={onClick} disabled={disabled}>
      <span className="send-message-btn-text">{children}</span>
      <span className="arrow">→</span>
    </button>
  );
};

export default SendMessageButton; 